import { Content } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { logo_carousel_helper } from "@/helpers/logo_carousel_helper";
import * as additionalComponents from "./__components";
import { createTitle } from "@/functions/createTitle";
import { getNestedRoutes } from "@/functions/getNestedRoutes";
import sn from "@/snippets";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} logoCarousel={false} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const page = simple_pages_helper.find(url_slug, "url_slug", "3ac0b752-94d4-49ee-b17a-c45aac2c5eda");
  const pages = getNestedRoutes({
    url_slugs: ["recruitment-solutions", "industry-insights", url_slug],
    overwrites: { "recruitment-solutions": { href: "/recruitment-solutions/why-choose-blue-arrow/" } },
  });
  const [_page, prevPage] = [...pages].reverse();

  if (!page) {
    return { notFound: true };
  }

  const relatedCategory = page["related_category"];
  const relatedSector = Array.isArray(page["related_sector"]) ? page["related_sector"] : [page["related_sector"]];

  const relatedArticlesItems = simple_pages_helper
    .filter((item) => item.related_category?.includes(relatedCategory ?? null))
    .filter((item) => relatedSector.some((tag) => item.related_sector.includes(tag)) ?? null)
    .filter((item) => item.id !== page.id);

  const logoItems = logo_carousel_helper.fetch();

  let content = [
    { component: "BreadcrumbNavigation", props: { items: pages } },
    sn.header({ page, prevPage }),
    {
      component: "IndustryInsightArticleContent",
      props: {
        id: page.id,
        title: page.title,
        intro: page.intro ?? null,
        body: page.body ?? null,
        embed_media: page.embed_media ?? null,
      },
    },
  ];

  page["additional_content"]?.map((item) =>
    content.push(
      sn.richText({
        page,
        config: {
          bodyKey: "additional_content",
        },
        contentId: item.title?.trim().replace(" ", "-").toLowerCase(),
        title: item.title ?? null,
        body: item.content,
      }),
    ),
  );

  content.push(
    sn.statCounterWidget({ page }),
    ...sn.narrativePanels({ page }),
    sn.richText({
      page,
      config: { bodyKey: "narrative_panels_footer" },
      className: "my-4 my-md-5",
    }),
    page["testimonials_items"] && page["testimonials_items"].length > 0
      ? sn.blockQuote({
          page,
          items: page["testimonials_items"]?.map((quote) => ({
            quote: quote.quote ?? null,
            author: {
              name: quote.author ?? null,
              position: quote.position ?? null,
              company: quote.company ?? null,
            },
          })),
        })
      : [],
    ...(relatedArticlesItems && relatedArticlesItems.length > 0
      ? [
          {
            component: "IndustryInsightsFeed",
            props: {
              title: "Related Articles",
              showFilters: false,
              items: relatedArticlesItems.slice(0, 3),
            },
          },
        ]
      : []),
    sn.multiCards({ page }),
    {
      component: "LogoCarousel",
      props: {
        items: logoItems,
        title: { path: "component.logoCarousel.title", placeholder: "Our Partners" },
      },
    },
    sn.chatbot({ page }),
  );

  return {
    notFound: !page,
    props: {
      meta: {
        title: createTitle(page.title),
        canonical: "https://www.bluearrow.co.uk" + getRoute("simplePage", { url_slug: url_slug }),
      },
      content,
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: simple_pages_helper.toPaths({
      exclude: ["8479686f-1c21-40c0-8054-bbfc02e95e16"],
      parent: "3ac0b752-94d4-49ee-b17a-c45aac2c5eda",
    }),
    fallback: false,
  };
}
